module.exports = __webpack_public_path__ + "static/media/beach2385.a320e01d.jpg";